// src/utils/cryptoUtils.js

/**
 * Gera um hash SHA-256 de uma string usando a Web Crypto API nativa dos navegadores.
 * @param {string} text - Senha ou texto em texto puro.
 * @returns {Promise<string>} - String hexadecimal do hash.
 */
export async function hashPassword(text) {
    if (!text) return '';
    try {
        const encoder = new TextEncoder();
        const data = encoder.encode(text);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    } catch (err) {
        console.error("Erro ao gerar hash SHA-256:", err);
        // Fallback básico caso crypto.subtle não esteja disponível em HTTP inseguro
        return btoa(unescape(encodeURIComponent(text)));
    }
}
